/**
 * Converts filterType string to withImages boolean parameter
 *
 * @param filterType - The filter type string (e.g., "withImages", "featured", "none")
 * @returns boolean | undefined - true for withImages filter, undefined for others
 */
export const getWithImagesFromFilterType = (
  filterType?: string
): boolean | undefined => {
  if (filterType === "withImages") {
    return true;
  }
  return undefined;
};

/**
 * Converts filterType string to tag parameter for GraphQL queries
 *
 * @param filterType - The filter type string (e.g., "featured", "withImages", "none")
 * @returns "FEATURED" for featured filter, null for others
 */
export const getTagFromFilterType = (filterType?: string) => {
  if (filterType === "featured") {
    return "FEATURED" as const;
  }
  if (filterType === "qa") {
    return "QA" as const;
  }
  return null;
};
